import styled from 'styled-components';

import { smallGap, mediumGap, largeGap } from '~theme';

const Spacing = props =>
  props.horizontal ? <HGap {...props} /> : <VGap {...props} />;

const HGap = styled.div`
  display: inline-block;
  width: ${props =>
    props.small
      ? smallGap
      : props.medium
      ? mediumGap
      : props.large
      ? largeGap
      : '0px'};
`;

const VGap = styled.div`
  height: ${props =>
    props.small
      ? smallGap
      : props.medium
      ? mediumGap
      : props.large
      ? largeGap
      : '0px'};
`;

export default Spacing;
